module.exports = __webpack_public_path__ + "media/images/google-play-badge-34b7353bfebb3a979e194a9a4173b882.svg";